// extracted by mini-css-extract-plugin
module.exports = {"container":"DashboardSection_container__1_6Rv","heading":"DashboardSection_heading__2tovI","content":"DashboardSection_content__1UjBs"};